// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/inventory/location/exists.php
export default {
	name: 'collection.inventory.location.exists',
	priority: 85,
	require: function(config, filter, data) {
		return filter.inventory && filter.inventory.location && filter.inventory.location.exists && config.can && config.can['view.inventory.location']
	},
	run: function(config, filter, data, query) {
		if (filter.inventory.location.exists == 1) {
			query.where('c.collection_private_location', '<>', '')
		}
		if (filter.inventory.location.exists == 2) {
			query.where('c.collection_private_location', '=', '')
		}
	}
}
